import { IconButton, Popover, useTheme } from '@forgeglobal/design-framework'
import { bindPopover, usePopupState } from 'material-ui-popup-state/hooks'
import React, { ReactNode, useRef } from 'react'

export const PopoverAction: React.FC<{ actionMenu: ReactNode; icon: ReactNode }> = ({ actionMenu, icon }) => {
  const theme = useTheme()
  const ref = useRef(null)
  const popupState = usePopupState({ variant: 'popover', popupId: 'action-popover' })
  const stopProp = (evt: React.MouseEvent | React.TouchEvent) => {
    evt.preventDefault()
    evt.stopPropagation()
  }
  const onClick = (evt: React.MouseEvent) => {
    popupState.toggle(ref.current)
    stopProp(evt)
  }
  return (
    <span ref={ref}>
      <IconButton
        style={{ marginLeft: theme.spacing(3) }}
        onClick={onClick}
        onMouseDown={stopProp}
        onTouchStart={stopProp}>
        {icon}
      </IconButton>
      <Popover
        elevation={4}
        {...bindPopover(popupState)}
        onClick={stopProp}
        onMouseDown={stopProp}
        onTouchStart={stopProp}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <div onClick={popupState.toggle}>{actionMenu}</div>
      </Popover>
    </span>
  )
}
